// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './vue/router';
import './assets/scss/global.scss';
import ElementUI from 'element-ui';
import Vuex from 'vuex';
import store from './vue/vuex/store';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Ads from 'vue-google-adsense'
import axios from 'axios'

import global from '@/assets/js/global';
import imageEditor from '@/assets/js/imageEditor';
import UploadImage from '@/vue/components/UploadImage/';
import util from '@/assets/js/util.js';

// 注册公共组件
import Header from '@/vue/components/Header/';
import Footer from '@/vue/components/Footer/';
import HeadTips from '@/vue/components/HeadTips/';
import Share from '@/vue/components/Share/';
import Download from '@/vue/components/Download/';
import LinkTo from '@/vue/components/LinkTo';
import GoogleAdsense from '@/vue/components/GoogleAdsense';
import Rules from '@/vue/components/Rules'


Vue.component("v-header", Header);
Vue.component("v-footer", Footer);
Vue.component("head-tips", HeadTips);
Vue.component("v-share", Share);
Vue.component("v-download", Download);
Vue.component("v-link-to", LinkTo);
Vue.component("upload-images", UploadImage);
Vue.component('v-google-adsense', GoogleAdsense);
Vue.component('v-rules', Rules);

Vue.use(ElementUI);
Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);
Vue.use(global);
Vue.use(imageEditor);
Vue.use(util);
Vue.use(Vuex);

Vue.config.productionTip = false

Vue.prototype.$axios = axios

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js